module.exports = __webpack_public_path__ + "assets/img/banner-logo.fe4fa1e3.png";